export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20abstract%20background%20with%20flowing%20gradients%20of%20creamy%20yellow%20and%20soft%20peach%20tones%2C%20subtle%20geometric%20shapes%20floating%20gently%2C%20modern%20minimalist%20design%20with%20smooth%20textures%2C%20photography%20and%20creative%20editing%20concept%2C%20elegant%20and%20inviting%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20abstract%20composition&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="黄油下载 - 黄油相机官方安全下载平台"
        title="黄油下载 黄油相机下载 黄油相机官方下载"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-50/20 backdrop-blur-sm rounded-full mb-6">
            <i className="ri-verified-badge-line text-accent-400 text-sm"></i>
            <span className="text-sm text-background-50/90">官方安全下载 · 最新版本 v8.0</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight mb-5">
            黄油相机
            <span className="block text-2xl md:text-3xl lg:text-4xl mt-2 font-sans font-light text-background-50/80">
              让每张照片都有故事
            </span>
          </h1>

          <p className="text-base md:text-lg text-background-50/70 max-w-2xl mx-auto mb-8 leading-relaxed">
            专业文字与滤镜美化工具，海量字体、滤镜与模板，一键下载即可体验。
            支持 iOS 与 Android 设备，让你的照片瞬间高级感爆棚。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#download"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-download-line text-lg"></i>
              立即免费下载
            </a>
            <a
              href="#features"
              className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 rounded-full text-base font-medium hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-arrow-down-line text-lg"></i>
              了解更多
            </a>
          </div>

          <div className="flex items-center justify-center gap-6 mt-8">
            <div className="flex items-center gap-2 text-background-50/60 text-sm">
              <i className="ri-apple-line"></i>
              <span>iOS</span>
            </div>
            <div className="w-px h-4 bg-background-50/20"></div>
            <div className="flex items-center gap-2 text-background-50/60 text-sm">
              <i className="ri-android-line"></i>
              <span>Android</span>
            </div>
            <div className="w-px h-4 bg-background-50/20"></div>
            <div className="flex items-center gap-2 text-background-50/60 text-sm">
              <i className="ri-star-line"></i>
              <span>500万+ 用户信赖</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}